<script lang="ts">
  import Bookmarks from '$lib/components/news/bookmarks/Bookmarks.svelte';
</script>

<svelte:head>
  <title>Lesezeichen</title>
</svelte:head>

<Bookmarks />
